import type { SVGProps } from 'react';
export const IconKitCloseMap = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width={48}
      height={48}
      rx={24}
      fill="#BB683C"
    />
    <path
      d="M24 24L18 18M24 24L30 18M24 24L30 30M24 24L18 30"
      stroke="white"
      strokeLinecap="round"
    />
  </svg>
);
